import React, {
  useCallback, useState, useMemo, ReactElement,
} from 'react';
import Card from '../../../../components/card/card.component';
import Button from '../../../../components/button/button.component';
import ModalButtonBlock from '../../../../components/modal-button-block/modal-button-block.component';
import ModalLabel from '../../../../components/modal-label/modal-label.component';
import ModalLayout from '../../../../components/modal-layout/modal-layout.component';
import ModalFieldBlock from '../../../../components/modal-field-block/modal-field-block.component';
import ErrorBlock from '../../../../components/error-block/error-block.component';
import FieldSelect from '../../../../components/field-select/field-select.component';
import MenuItemList from '../../../../components/menu-item-list/menu-item-list.component';
import PersonDefaultImage from '../../../../static/images/person-default-image.png';

const ShareModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isOpen,
    title,
    description,
    errorMessage,
    contactLinkedUserList,
    onShareClick,
    onCloseModal,
  } = props;

  const [contactId, setContactId]: [number, Function] = useState<StateValueDefault>('');

  const menuItemContactLinkedUserList: ReactElement[] = useMemo((): ReactElement[] => MenuItemList({
    withImage: true,
    isExtended: true,
    optionItemLabelKey: 'fullName',
    optionItemExtraLabelKey: 'email',
    optionList: contactLinkedUserList,
    defaultImage: PersonDefaultImage,
  }), [contactLinkedUserList]);

  const onContactChange: Function = useCallback((userIdValue: number): void => {
    setContactId(userIdValue);
  }, []);

  const shareClick: MouseEventHandlerFunction = useCallback((): void => {
    if (onShareClick) {
      const contactUser: Contact = contactLinkedUserList.find((contactItem: Contact): boolean => (
        contactItem.id === contactId
      ));

      if (contactUser && contactUser.user && contactUser.user.id) {
        onShareClick(contactUser.user.id, (): void => {
          setContactId('');
        });
      }
    }
  }, [contactId]);

  return (
    <ModalLayout isOpen={isOpen} title={title} onCloseModal={onCloseModal}>
      <Card isContainer>
        {
          description && (
            <ModalLabel>
              {description}
            </ModalLabel>
          )
        }
        <ModalLabel>
          Select a contact to share with:
        </ModalLabel>
        <ModalFieldBlock>
          <FieldSelect
            isPlain
            isBordered
            withBlankElement
            isDisabled={contactLinkedUserList && !contactLinkedUserList.length}
            value={contactId}
            onChange={(event: EventSelectChange, value: string): void => {
              onContactChange(value);
            }}
          >
            {menuItemContactLinkedUserList}
          </FieldSelect>
        </ModalFieldBlock>
      </Card>
      <ModalButtonBlock>
        <Button onClick={onCloseModal}>
          Cancel
        </Button>
        <Button isActive onClick={shareClick}>
          Share
        </Button>
      </ModalButtonBlock>
      {
        !!errorMessage && (
          <ErrorBlock errorMessage={errorMessage} />
        )
      }
    </ModalLayout>
  );
});

export default ShareModal;
